export const testimonials = [
  {
    name: "Manan Atal",
    position: "Software Developer",
    testimonial:
      "CSI has truly created a vibrant and supportive community for tech enthusiasts like me. The regular meetups and workshops have not only expanded my knowledge but also allowed me to connect with like-minded individuals. What stands out to me is the genuine camaraderie among members, whether it's through collaborative projects or simply sharing insights during discussions",
    avatar:
      "https://res.cloudinary.com/dymfhvwou/image/upload/v1710690771/AITRCSI/dummy1-removebg-preview_yo9l8k.png",
  },
  {
    name: "Kanishka Kanungo",
    position: "Chairperson",
    testimonial:
      "The range of workshops and seminars offered by CSI is impressive, covering various aspects of technology. To further enhance skill development, consider organizing hands-on coding sessions or hackathons where members can apply what they've learned in a practical setting. ",
    avatar: "https://res.cloudinary.com/dymfhvwou/image/upload/v1710435899/AITRCSI/Kanishka_Kanungo_s9i0no.png",
  },
  {
    name: "Nishchal Vyas",
    position: "Software Developer Lead",
    testimonial:
      "CSI could strengthen its industry connections by inviting more guest speakers from diverse sectors of the tech industry. Additionally, facilitating mentorship programs or industry visits would provide valuable insights and networking opportunities for members looking to transition into the professional world. ",
    avatar: "https://res.cloudinary.com/dymfhvwou/image/upload/v1710008266/AITRCSI/IMG-20240224-WA0004_-_Nishchal_Vyas_z4yzof.jpg",
  },
  {
    name: "Nidhish Sharma",
    position: "Vice Chairperson",
    testimonial:
      "While CSI has been supportive of member projects, encouraging more collaboration among members on interdisciplinary projects could lead to innovative solutions. Moreover, promoting participation in external competitions and providing guidance on project management would further enhance members' practical skills.",
    avatar: "https://res.cloudinary.com/dymfhvwou/image/upload/v1710008646/AITRCSI/WhatsApp_Image_2024-03-09_at_23.53.18_b26d4083_crttvd.jpg",
  },
  {
    name: "Kritika Rathore",
    position: "Event Manager",
    testimonial:
      "Maintaining transparent communication channels regarding club activities and opportunities is crucial. Consider establishing a centralized platform, such as a newsletter or online portal, where members can easily access information about upcoming events, resources, and opportunities for involvement.",
    avatar: "https://res.cloudinary.com/dymfhvwou/image/upload/v1710008642/AITRCSI/WhatsApp_Image_2024-03-09_at_23.53.01_c3f39b11_wqaof6.jpg",
  },
  {
    name: "Somesh Shukla",
    position: "Engagement Head",
    testimonial:
      "CSI's workshops and training sessions have been beneficial for members seeking to enhance their technical skills. To cater to a wider range of interests, consider diversifying the topics covered and offering advanced-level sessions for experienced members. CSI have not only enriched my understanding of the tech industry but have also helped me kickstart my career journey with confidence.",
    avatar: "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436198/AITRCSI/Somesh_Shukla_xlsc1g.png",
  },
];